import React, { useEffect, useState } from "react";
import "./Home.css";
import ReactPlayer from "react-player";
import IndexSection from "../../components/reusable/IndexSection/IndexSection";
import BIDCarousel from "../../components/reusable/BIDCarousel/BIDCarousel";
import BIDPlayIcon from "../../components/reusable/BIDPlayIcon/BIDPlayIcon";
//import LACVolume from "./LACVolume";
//import GeneralFeelingsCar from "./GeneralFeelingsCar";
import SurveyGraph from "./SurveyGraph";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/homepage.json";
//import LinkWithLanguage from "../../components/reusable/LinkWithLanguage/LinkWithLanguage";

/**
 *
 * @returns Home page component
 */
export default function Home() {
  const { language } = useCurrentLanguage();

  const [reactPlayerHeigth, setReactPlayerHeight] = useState("100%");

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="home-container">
      <div className="home-banner">
        <div className="home-main-text">
          <h1 className="home-main-title">{TEXT["title"][language]}</h1>
          <h3 className="home-main-subtitle">{TEXT["subtitle"][language]}</h3>
          <p className="home-main-description">
            {TEXT["description"][language]}
          </p>
        </div>
        <div className="home-video full-screen">
          <div className="home-video-wrapper">
            <ReactPlayer
              // light={"thumbnail.png"}
              width={"100%"}
              height={reactPlayerHeigth}
              onStart={() => setReactPlayerHeight("auto")}
              controls={true}
              muted={true}
              volume={0.8}
              playing={true}
              loop={false}
              playIcon={<BIDPlayIcon />}
              url={language === "en" ? "homeVideo_EN.mp4" : "homeVideo_ES.mp4"}
            />
          </div>
        </div>
      </div>
      {/* <div className="home-pnud-banner">
        <div>
          {TEXT["pnud"][language]} <br />
          <LinkWithLanguage
            to={language === 'es' ? "https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america" : "https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"}
            className="home-pnud-link"
            content={TEXT["pnudTitle"][language]}
            isLink={true}
          />
        </div>
          <img
          className="home-pnud-image"
            src={require(`./../../images/dashboard/${language === 'en' ? 'Estigmas_espanol' : 'Estigmas_espanol'}.png`)}
            alt="PNUD and BID Book Cover"
          />
      </div> */}
      <div className="home-subtitle">
        <p>{TEXT["carouselTitle"][language]}</p>
      </div>
      <div className="home-graph-carousel full-screen">
        <BIDCarousel>
          <SurveyGraph key={0} question={'p32inn_Q1'}/>
          <SurveyGraph key={1} question={'p33st_b_Q1'}/>
          <SurveyGraph key={2} question={'p33n_c_Q1'}/>
        </BIDCarousel>
      </div>
      <div className="home-page-descriptions">
        <IndexSection
          to="encuestas"
          title={TEXT["surveysIndexTitle"][language]}
          subtitle={TEXT["surveysIndexSubtitle"][language]}
          description={TEXT["surveysIndexDescription"][language]}
          to2="encuestas?survey=nac"
          subtitle2={TEXT["surveysIndexSubtitle2"][language]}
          description2={TEXT["surveysIndexDescription2"][language]}
          image="surveys.png"
          language={language}
        />
        <IndexSection
          to="conversacion"
          title={TEXT["dataIndexTitle"][language]}
          subtitle={TEXT["dataIndexSubtitle"][language]}
          description={TEXT["dataIndexDescription"][language]}
          isImgLeft={true}
          image="data.png"
          language={language}
        />
        <IndexSection
          to="experimentos"
          title={TEXT["knowledgeIndexTitle"][language]}
          subtitle={TEXT["knowledgeIndexSubtitle"][language]}
          description={TEXT["knowledgeIndexDescription"][language]}
          image="knowledge.png"
          language={language}
        />
        <IndexSection
          to="recursos"
          title={TEXT["resourcesIndexTitle"][language]}
          subtitle={TEXT["resourcesIndexSubtitle"][language]}
          description={TEXT["resourcesIndexDescription"][language]}
          isImgLeft={true}
          image="resources.png"
          language={language}
        />
      </div>
      <div className="home-about full-screen grid-background">
        <div className="home-about-text">
          <h1 className="home-about-title">
            {TEXT["aboutIndexTitle"][language]}
          </h1>
          <p className="home-about-description">
            {TEXT["aboutIndexDescription"][language]}
          </p>
        </div>
      </div>
    </div>
  );
}
